module.exports = __webpack_public_path__ + "38e27b684c0a7f079cc7e1762e5e1ade.svg";